import { reportActions } from '../actions'

const {
  FETCH_AVAILABLE_REPORTS,
  FETCHING_AVAILABLE_REPORTS,
  FETCH_REPORTS_ERROR,
  CHANGE_CURRENT_REPORT,
  FETCHING_REPORT_LIST,
  FETCH_REPORT_LIST,
  FETCH_REPORT_LIST_ERROR,
  FETCHING_INVOICE_LIST,
  FETCH_INVOICE_LIST
} = reportActions

const initialState = {
  available_reports: [],
  last_update: null,
  fetching: {
    available_reports: false,
  },
  fetch_errors: {
    available_reports: false
  },
  current_report: {}
}

const report = (state = initialState, action = '') => {
  switch (action.type) {
    case FETCHING_AVAILABLE_REPORTS:
      return {
        ...state,
        fetching: {
          ...state.fetching,
          available_reports: true
        },
        fetch_errors: {
          ...state.fetch_errors,
          available_reports: false
        }
      }
  
    case FETCH_AVAILABLE_REPORTS:
      return {
        ...state,
        available_reports: action.items,
        current_report: action.items.find(item => item.label === state.current_report.label) || action.items[action.items.length - 1],
        fetching: {
          ...state.fetching,
          available_reports: false
        },
        fetch_errors: {
          ...state.fetch_errors,
          available_reports: false
        }
      }
      
    case FETCH_REPORTS_ERROR:
      return {
        ...state,
        fetching: {
          ...state.fetching,
          available_reports: false
        },
        fetch_errors: {
          ...state.fetch_errors,
          available_reports: true
        }
      }

    case CHANGE_CURRENT_REPORT:
      return {
        ...state,
        current_report: action.report
      }

      case FETCHING_REPORT_LIST:
        return {
          ...state,
          fetching: {
            ...state.fetching,
            reportList: action.value
          },
          fetch_errors: {
            ...state.fetch_errors,
            reportList: false
          }
        }
      
      case FETCH_REPORT_LIST:
        return {
          ...state,
          reportList: action.items,
          areaResponsible: action.areaResponsible,
          businessUnitResponsible: action.businessUnitResponsible,
          last_update: action.last_update,
          fetching: {
            ...state.fetching,
            reportList: false
          },
          fetch_errors: {
            ...state.fetch_errors,
            reportList: false
          }
        }
      
        case FETCH_REPORT_LIST_ERROR:
          return {
            ...state,
            fetching: {
              ...state.fetching,
              reportList: false
            },
            fetch_errors: {
              ...state.fetch_errors,
              available_reports: true
            }
          }
  
      case FETCH_INVOICE_LIST:
        return {
          ...state,
          invoiceList: action.items,
          fetching: {
            ...state.fetching,
            invoiceList: false
          }
        }
  
      case FETCHING_INVOICE_LIST:
        return {
          ...state,
          fetching: {
            ...state.fetching,
            invoiceList: action.value
          }
        }
  
    
    default:
      return state
  }
}

export default report



// WEBPACK FOOTER //
// ./src/reducers/report.js